export const staffRoles = [
  'Constituent Liaison',
  'Intern',
  'Director of Constituent Services',
  'Chief of Staff',
  'Council Member',
  'Transition Team',
]
